/// <reference path="../../../../tools/typings/angularjs/angular.d.ts"/>
/// <reference path="../../components.ts"/>

module DealerwareWebComponents {
    "use strict";

    export class CreateCustomerModalController {
        public static $inject : string[] = [
            '$mdMedia',
            '$mdDialog',
            'DealerwareCustomerModel'
        ];

        public locationId: number;
        public onCreateSuccess: any;
        public showLanguage: any;

        constructor(public $mdMedia: any,
                    public $mdDialog: any,
                    public DealerwareCustomerModel: any) {
                        this.showLanguage = false;
                    }

        public get useFullScreen() {
            return (this.$mdMedia('xs') || this.$mdMedia('sm'));
        }

        public showModal() {
            var _self = this;

            this.$mdDialog.show({
                controller: DialogController,
                templateUrl: '/components/customer/create/create_customer_modal_directive.html',
                locals: {
                    customer: new this.DealerwareCustomerModel(),
                    locationId: this.locationId,
                    showLanguage: this.showLanguage,
                    successCallback: this.onCreateSuccess
                },
                parent: angular.element(document.body),
                clickOutsideToClose: false,
                fullscreen: _self.useFullScreen
            });

            function DialogController($scope: any,
                                      $mdDialog: any,
                                      $dealerwareNotification: any,
                                      DataUtils: any,
                                      customer: any,
                                      locationId: any,
                                      successCallback: any) {
                $scope.dataUtils = DataUtils.getInstance();
                $scope.customer = customer;
                $scope.saving = false;

                $scope.createCustomer = () => {
                    $scope.saving = true;
                    $scope.customer.$save({
                        promise: true,
                        params: { location_id: locationId }
                    }).then(
                        (customer: any) => {
                            $scope.saving = false;
                            $scope.closeDialog();
                            if (successCallback && angular.isFunction(successCallback)) {
                                successCallback({customer: customer});
                            }
                        },
                        (response: any) => {
                            $scope.saving = false;
                            $dealerwareNotification.apiError(response, undefined, { multiple: true });
                        }
                    );
                }

                $scope.closeDialog = () => {
                    $mdDialog.hide();
                }
            }
        }
    }

    getDealerwareWebComponentsModule().controller('CreateCustomerModalController', CreateCustomerModalController);


    export class CreateCustomerModalDirective implements ng.IDirective {

        public restrict         : string    =   'A';
        public controller       : any       =   'CreateCustomerModalController';
        public controllerAs     : string    =   'createCustomerModalController';
        public bindToController : boolean   =   true;
        public replace          : boolean   =   false;
        public scope            : Object    =   {
            locationId: '=',
            onCreateSuccess: '&'
        };
        public transclude       : boolean   =   false;
        public static $inject   : string[]  =   [];

        constructor() {}

        public link : ng.IDirectiveLinkFn = (
            scope   :   ng.IScope,
            elem :   ng.IAugmentedJQuery,
            attrs   :   ng.IAttributes,
            ctrls   :   any
        ) => {
            elem.bind('click', function() {
                ctrls.showModal();
            });
        }
    }

    // register the directive
    getDealerwareWebComponentsModule().directive("dealerwareCreateCustomerModal",() => new CreateCustomerModalDirective());

}